import { max } from "date-fns";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoTemplate from "../../../Assets/images/logoh.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// export const ShopCardStyle = ({link, title,CatId, desc, btnValue, minCash,maxCash}) => {
export const ShopCardStyle = ({ ...product }) => {
  const {
    CatId,
    ShopId,
    Title,
    MinimumCashBack,
    MaxsimumCashBack,
    WebSite,
    Logo,
    isCategory,
    cashback,
  } = product;
  const roundValue = (number) => {
    const formattedNumber = number % 1 === 0 ? parseInt(number) : number;
    return formattedNumber;
  };
  const navigate = useNavigate();
  return (
    <div key={CatId} className="col mb-4">
      <div className="card-with-shadow">
        <Link to={`https://${WebSite}?R=taab30`}>
          <div className="shop-card-header">
            <img
              src={isCategory ? product?.catpic : Logo || LogoTemplate}
              className="card-img-top "
              alt={Title}
            />
          </div>
        </Link>
        <div className="shop-card-body d-flex align-items-center">
          <div className="d-flex justify-content-between align-tems-center">
            <Link to={`https://${WebSite}?R=taab30`}className="text-decoration-none text-dark">
              <h4 className="card-title cursor-pointer">
                {isCategory? product.cattitle: Title}
              </h4>
            </Link>
            {/* <p className="card-text">دسته بندی</p> */}
          </div>
          <div className="d-flex  justify-content-between align-items-center ">
            <div className="shop-card-text">
              <FontAwesomeIcon icon="coins" className="text-warning fs-6" />
              <span className="card-text"> {roundValue(MinimumCashBack)}</span>
              <span className="card-text">
                {/* {isCategory ?} */} تا{" "}
                {isCategory ? cashback : roundValue(MaxsimumCashBack) || ""}% کش
                بک
              </span>
            </div>
            <div>
              <Link to={`https://${WebSite}?R=taab30`}>
                {/* <button className="btn btn-light">ورود به فروشگاه</button> */}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// to={isCategory? product?.catUrl :`/shopprofile/${ShopId} `} 